import * as React from 'react';
const RussareIcon = ({ primaryColor, secondaryColor, width }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="prefix__Livello_2"
    data-name="Livello 2"
    viewBox="0 0 200 200"
    style={{ width }}
  >
    <defs>
      <style>{`.prefix__cls-1{fill:${secondaryColor ||
        '#ffcf38'}}.prefix__cls-2{fill:none;stroke:${primaryColor ||
        '#282828'};stroke-linecap:round;stroke-linejoin:round;stroke-width:3.89px}`}</style>
    </defs>
    <path
      d="M98.05 55.59c.59-.1 1.24-.21 1.95-.31 11.71-1.62 23.89 1.78 30.05 12.39 3.8 6.25 5.52 13.76 4.9 21.07-.63 7.47-5.02 13.38-8.43 19.79-2.43 4.57-4.09 9.67-3.98 14.85M99.25 121.8c-4.34 3.2-9 5.77-14.14 7.27-3.58 1.04-8.09 2.09-11.54 0-1.5-.9-2.63-2.69-2.42-4.51.09-.79.43-1.53.52-2.32s-.09-1.39-.74-1.78c-.57-.34-1.12-.77-1.49-1.35s-.55-1.33-.35-2 .85-1.18 1.51-1.13c-.74-.12-1.45-.65-1.81-1.35s-.39-1.58-.08-2.31c.18-.42.45-.77.67-1.16s.39-.84.33-1.29-.32-.83-.75-.78c-.77-.37-1.56-.75-2.23-1.31-2.46-2.06-2.22-4.36-.42-6.86 1.42-1.97 2.96-4.09 3.58-6.46.7-2.67.24-5.51.33-8.22.16-4.79 1.92-9.61 4.55-13.93M130.49 145.1c-2.99-4.41-5.45-9.74-6.87-15.03M86.13 128.92c2 5.56 4.38 10.98 7.12 16.19"
      className="prefix__cls-2"
    />
    <path
      d="M107.58 95.6c.81-1.75 2.03-3.37 3.73-4.15 1.69-.79 3.9-.55 5.11.91.9 1.07 1.13 2.58 1.16 4.01.07 3.55-.94 7.12-2.85 10.05-.86 1.32-1.92 2.53-3.25 3.29-1.34.76-2.99 1.02-4.4.43"
      className="prefix__cls-2"
    />
    <path
      d="M111.35 99.91c-.36.94-.86 1.82-1.49 2.61-.03.03-.07.07-.11.05s.03-.09.03-.05"
      className="prefix__cls-2"
    />
    <path
      d="m89.79 66.25.44-2.19a.78.78 0 0 0-.62-.93l-4.13-.82 6.04-5.86c.12-.11.19-.26.23-.41l.31-1.53a.78.78 0 0 0-.62-.93l-8.52-1.7a.78.78 0 0 0-.93.62l-.44 2.19c-.09.43.19.85.62.93l3.65.73-6.17 5.94c-.12.11-.2.26-.23.42l-.29 1.43c-.09.43.19.85.62.93l9.11 1.82c.43.09.85-.19.93-.62ZM103.56 67.87l-5.95-4.12a.66.66 0 0 0-.92.17l-1.06 1.53c-.21.3-.13.71.17.92l2.55 1.77-6.69 2.5c-.13.05-.23.13-.31.24l-.69 1c-.21.3-.13.71.17.92l6.37 4.41c.3.21.71.13.92-.17l1.06-1.53a.66.66 0 0 0-.17-.92l-2.88-2 6.56-2.48c.13-.05.23-.13.31-.24l.74-1.07a.66.66 0 0 0-.17-.92ZM87.32 79.77l-.3-1.6a.577.577 0 0 0-.67-.46l-3 .57 2.47-5.58c.05-.11.06-.22.04-.34l-.21-1.11a.577.577 0 0 0-.67-.46l-6.19 1.17c-.31.06-.52.36-.46.67l.3 1.6c.06.31.36.52.67.46l2.65-.5-2.54 5.67c-.05.11-.06.23-.04.34l.2 1.04c.06.31.36.52.67.46l6.62-1.25c.31-.06.52-.36.46-.67Z"
      className="prefix__cls-1"
    />
    <circle cx={85.03} cy={86.3} r={2.57} className="prefix__cls-1" />
    <circle cx={85.75} cy={92.73} r={1.96} className="prefix__cls-1" />
    <path
      d="M83.15 95.72a1.494 1.494 0 1 0-.59 2.93 1.494 1.494 0 0 0 .59-2.93"
      className="prefix__cls-1"
    />
  </svg>
);
export default RussareIcon;
